import {  motocaddyBackendPortalRequest } from "../apiConfig";
import { CountryList, StateList } from "../apiRequest";

export const GetCountryList = async (body,user) => {
    const res = await motocaddyBackendPortalRequest(CountryList,body,user );
    return res.data;
  };
export const GetStateList = async (body,user) => {
    const res = await motocaddyBackendPortalRequest(StateList,body,user );
    return res.data;
  };